import { createSelector } from 'reselect';

export const selectRentalsSlice = state => state.rentals;

export const selectRentals = createSelector(
  selectRentalsSlice,
  slice => slice.rentals
);
export const rentalsLoaded = createSelector(
  selectRentalsSlice,
  slice => slice.rentalsLoaded
);
export const selectActiveRental = createSelector(
  selectRentalsSlice,
  slice => slice.activeRental
);

export const rentalsMeta = createSelector(
  selectRentalsSlice,
  slice => slice.meta
);
export const rentalsFilters = createSelector(
  selectRentalsSlice,
  slice => slice.filters
);
export const rentalsEvent = createSelector(
  selectRentalsSlice,
  slice => slice.eventId
);

export const rentalCreating = createSelector(
  selectRentalsSlice,
  slice => slice.isCreating
);
export const rentalUpdating = createSelector(
  selectRentalsSlice,
  slice => slice.isUpdating
);
export const rentalDeleting = createSelector(
  selectRentalsSlice,
  slice => slice.isDeleting
);
export const rentalsErrors = createSelector(
  selectRentalsSlice,
  slice => slice.errors
);
